export default "__VITE_ASSET__TeEZ380a__"